var map = {
	"./CircleStar.png": 5337,
	"./Hackathon.png": 2742,
	"./Language.png": 3647,
	"./Policies.png": 9023,
	"./chevron.svg": 6180,
	"./close-black.svg": 8315,
	"./close.svg": 5837,
	"./cross.svg": 9973,
	"./flip.svg": 670,
	"./info-orange.svg": 5570,
	"./info.svg": 6947,
	"./nav-toggle.svg": 5323,
	"./play-grey.svg": 8963,
	"./play.svg": 757,
	"./tick.svg": 6920
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5853;